export default "__VITE_ASSET__CiojnlhB__"